import styled from "styled-components";

const AuthInnerDiv = styled.div`
  width: 100%;
  max-width: 650px;
  padding: 40px 16px 45px 16px;
  background: black;
  @media (min-width: 425px) {
    max-width: 450px;
    padding: 40px 16px 45px 16px;
  }
  @media (min-width: 456px) {
    max-width: 500px;
    padding: 40px 16px 45px 16px;
  }
`;

const AuthContainer = ({ children }) => {
  return (
    <div className="auth-body">
      <div className="auth-wrapper">
        <AuthInnerDiv className="auth-inner">{children}</AuthInnerDiv>
      </div>
    </div>
  );
};

export { AuthContainer };
